import { render, staticRenderFns } from "./EditBasicPoll.vue?vue&type=template&id=200f0917&scoped=true&"
import script from "./EditBasicPoll.vue?vue&type=script&lang=ts&"
export * from "./EditBasicPoll.vue?vue&type=script&lang=ts&"
import style0 from "./EditBasicPoll.vue?vue&type=style&index=0&id=200f0917&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200f0917",
  null
  
)

export default component.exports